import React, { useEffect } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import LocalShipping from "../../../../assets/icons/land.png";
// import Flight from "../../../../assets/icons/air.png";

import { BodyUl, HeadUl, IconContainer } from "./styled.components";

import { Message, MessageSections } from "../../../components/message/message";
import BarekamButton, { ActionbarButtons } from "../../../components/button";
import BarekamChip from "../../../components/chip/barekamChip";
import BarekamText from "../../../components/text";
import { Title } from "../Title/Title";
import { MessageLoader } from "../../../../router/blocks/route-components/message.loader";
import { getCountries } from "../../../../redux/slices/static-data.slice";
import Container from "../Container";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { getMessage } from "../../../shared/helper-functions";
import { BarekamIcon, IconVariants } from "../../../components/icon/barekam-icon";
import { useCalculatorModal } from "../../../../contexts/CalculatorModalContext";

const ShippingPrices: React.FC = () => {
  const dispatch = useAppDispatch();
  const { countries } = useAppSelector(state => state.staticDataReducer);
  const { languageId, messageCache } = useAppSelector((state) => state.messagesReducer);
  const theme = useTheme();
  const { openCalculator } = useCalculatorModal();

  const matchesPhone =
    useMediaQuery(theme.breakpoints.between(0, 768));

  useEffect(() => {
    dispatch(getCountries(true));
  }, [])


  return (
    <Container id="prices">
      <MessageLoader key={MessageSections.ORDERS} sectionName={MessageSections.ORDERS}>
        <Title variant="h2">
          <Message
            messageKey={"shipping_prices"}
            sectionId={MessageSections.MAIN}
          />
        </Title>
        <Box sx={{ width: "100%", maxWidth: '1000px' }}>
          <HeadUl>
            <li>
              <BarekamText variant={"m"} fontWeight={600} align={"left"}>
                <Message
                  messageKey={"sender_country"}
                  sectionId={MessageSections.MAIN}
                />
              </BarekamText>
            </li>
            <li>
              <IconContainer>
                <img src={LocalShipping} width="40px" height="40px" />
                <Box sx={{ lineHeight: "18px", marginLeft: "6px" }}>
                  <BarekamText variant={"m"} fontWeight={600} align={"left"}>
                    <Message
                      messageKey={"by_land"}
                      sectionId={MessageSections.ORDERS}
                    />
                  </BarekamText>
                  {!matchesPhone && (
                    <BarekamText variant={"s"} fontWeight={500} align={"left"}>
                      <Message
                        messageKey={"land_description"}
                        sectionId={MessageSections.ORDERS}
                      />
                    </BarekamText>
                  )}
                </Box>
              </IconContainer>
              {!matchesPhone && (
                <BarekamText variant={"m"} fontWeight={600} align={"left"}>
                  <Message
                    messageKey={"land_price_per_kg"}
                    sectionId={MessageSections.MAIN}
                  />
                </BarekamText>
              )}
            </li>
            {/* <li>
              <IconContainer>
                <img src={Flight} width="40px" height="40px" />
                <Box sx={{ lineHeight: "18px", marginLeft: "6px" }}>
                  <BarekamText variant={"m"} fontWeight={800} align={"left"}>
                    <Message
                      messageKey={"by_air"}
                      sectionId={MessageSections.ORDERS}
                    />
                  </BarekamText>
                  {!matchesPhone && (
                    <BarekamText variant={"s"} fontWeight={500} align={"left"}>
                      <Message
                        messageKey={"air_description"}
                        sectionId={MessageSections.ORDERS}
                      />
                    </BarekamText>
                  )}
                </Box>
              </IconContainer>
              {!matchesPhone && (
                <BarekamText variant={"m"} fontWeight={600} align={"left"}>
                  <Message
                    messageKey={"air_price_per_kg"}
                    sectionId={MessageSections.MAIN}
                  />
                </BarekamText>
              )}
            </li> */}
          </HeadUl>
          <div>
            {countries
              .filter(country => country.hasActiveWarehouse)
              .map((country) => (
                <BodyUl key={country.countryId}>
                  <li>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <BarekamIcon variant={IconVariants.flag} country={country.abbreviation.toLowerCase()} size={{ width: '24px', height: '24px' }} />
                      {country.name[languageId]}
                    </span>
                    {!country.hasActiveWarehouse && (
                      <BarekamChip
                        messageKey={"coming_soon"}
                        statusId={4}
                        chipSize={"s"}
                        styles={{ marginLeft: "0.5rem", display: "inline-block" }}
                      />
                    )}
                  </li>
                  <li>{country.hasActiveWarehouse ? `${country.warehouse[0].shippingPriceByLand} ${getMessage('amd', MessageSections.ORDERS, messageCache, languageId)}` : '-'}</li>
                  {/* <li>{country.hasActiveWarehouse ? `3000 ${getMessage('amd', MessageSections.ORDERS, messageCache, languageId)}` : '-'}</li> */}
                </BodyUl>
              ))}
            <BodyUl>
              <li>
                <BarekamText variant={"m"} fontWeight={500} align={"left"}>
                  <Message
                    messageKey={"coming_soon_countries_title"}
                    sectionId={MessageSections.MAIN}
                  />
                </BarekamText>
              </li>
              <li>
                <BarekamText variant={"m"} fontWeight={500} align={"left"}>
                  <Message
                    messageKey={"coming_soon_countries_list"}
                    sectionId={MessageSections.MAIN}
                  />
                </BarekamText>
              </li>
            </BodyUl>
          </div>
        </Box>
        <BarekamText
          variant={"l"}
          fontWeight={500}
          align={"left"}
          style={{ width: "100%" }}
        >
          <Message
            messageKey={"shipping_price_section_descripttion"}
            sectionId={MessageSections.MAIN}
          />
        </BarekamText>
        <BarekamButton
          type={ActionbarButtons.NEW}
          size={"l"}
          onClick={openCalculator}
        >
          <BarekamText variant={"m"} fontWeight={500} align={"center"}>
            <Message
              messageKey={"calculate"}
              sectionId={MessageSections.MAIN}
            />
          </BarekamText>
        </BarekamButton>
      </MessageLoader>
    </Container>
  );
};

export default ShippingPrices;
